/* eslint-disable */
import md5 from 'md5';
import { isVkPlay } from '@platform/shared';
import Tooltip from '@components/Tooltip';
import { PAGE_NAME } from '../../utils/services';

export default {
  name: 'CalcPage',
  components: {
    Tooltip,
  },
  page() {
    return {
      title: this.$i18n.t(isVkPlay ? 'docTitle.calcVkPlay' : 'docTitle.calc', { page: PAGE_NAME }),
    };
  },
  data() {
    return {
      currency_picked: null,
      billing_result: null,
      auth_result: null,
      auth_browser_result: null,
      profile_result: null,
      invite_result: null,
      pub_result: null,
      msg_result: null,
      achievement_result: null,
    };
  },

  methods: {
    billingCalc(event) {
      this.billing_result = {};
      const struct_object = {
        merchant_param: this.billing_merchantparam,
        sum: this.billing_sum,
        tid: this.billing_tid,
        uid: this.billing_uid,
      };
      // check currency
      if (this.currency_picked) {
        try {
          JSON.parse(this.billing_merchantparam || '{}');
        } catch (e) {
          alert('Wrong merchparam');
          location.reload();
        }

        let merch_obj = JSON.parse(this.billing_merchantparam || '{}');
        if (this.currency_picked === 'nil') {
          delete merch_obj.currency;
        } else {
          delete merch_obj.currency;
          const new_obj = { currency: this.currency_picked, ...merch_obj };
          merch_obj = new_obj;
        }
        this.billing_merchantparam = JSON.stringify(merch_obj);
        struct_object.merchant_param = this.billing_merchantparam;
      }
      // make result
      this.billing_result.dict_string = JSON.stringify(struct_object, null, 4);
      this.billing_result.concat_string = '';
      if (this.billing_merchantparam) {
        this.billing_result.concat_string += `merchant_param=${this.billing_merchantparam}`;
      }
      if (this.billing_sum) {
        this.billing_result.concat_string += `sum=${this.billing_sum}`;
      }
      if (this.billing_tid) {
        this.billing_result.concat_string += `tid=${this.billing_tid}`;
      }
      if (this.billing_uid) {
        this.billing_result.concat_string += `uid=${this.billing_uid}`;
      }

      this.billing_result.concat_string_secret = `${this.billing_result.concat_string}${this.billing_secret}`;
      this.billing_result.md5sum = md5(this.billing_result.concat_string_secret);
    },
    authCalc(event) {
      this.auth_result = {};
      const struct_object = {
        appid: this.auth_appid,
        hash: this.auth_hash,
        ip: this.auth_ip,
        uid: this.auth_uid,
      };
      this.auth_result.dict_string = JSON.stringify(struct_object, null, 4);
      this.auth_result.concat_string = '';
      if (this.auth_appid) {
        this.auth_result.concat_string += `appid=${this.auth_appid}`;
      }
      if (this.auth_hash) {
        this.auth_result.concat_string += `hash=${this.auth_hash}`;
      }
      if (this.auth_ip) {
        this.auth_result.concat_string += `ip=${this.auth_ip}`;
      }
      if (this.auth_uid) {
        this.auth_result.concat_string += `uid=${this.auth_uid}`;
      }
      this.auth_result.concat_string_secret = `${this.auth_result.concat_string}${this.auth_secret}`;
      this.auth_result.md5sum = md5(this.auth_result.concat_string_secret);
    },
    authBrowserCalc(event) {
      this.auth_browser_result = {};
      const struct_object = {
        appid: this.auth_browser_appid,
        uid: this.auth_browser_uid,
        currency: this.auth_browser_currency,
        lang: this.auth_browser_lang,
        extras: this.auth_browser_extras,

      };
      this.auth_browser_result.dict_string = JSON.stringify(struct_object, null, 4);
      this.auth_browser_result.concat_string = '';
      if (this.auth_browser_appid) {
        this.auth_browser_result.concat_string += `appid=${this.auth_browser_appid}`;
      }
      if (this.auth_browser_currency) {
        this.auth_browser_result.concat_string += `currency=${this.auth_browser_currency}`;
      }
      if (this.auth_browser_lang) {
        this.auth_browser_result.concat_string += `lang=${this.auth_browser_lang}`;
      }
      if (this.auth_browser_uid) {
        this.auth_browser_result.concat_string += `uid=${this.auth_browser_uid}`;
      }
      if (this.auth_browser_extras) {
        this.auth_browser_result.concat_string += this.auth_browser_extras;
      }
      this.auth_browser_result.concat_string_secret = `${this.auth_browser_result.concat_string}${this.auth_browser_secret}`;
      this.auth_browser_result.md5sum = md5(this.auth_browser_result.concat_string_secret);
    },
    profileCalc(event) {
      this.profile_result = {};
      const struct_object = {
        uid: this.profile_uid,
      };
      this.profile_result.dict_string = JSON.stringify(struct_object, null, 4);
      this.profile_result.concat_string = `uid=${this.profile_uid}`;
      this.profile_result.concat_string_secret = `${this.profile_result.concat_string}${this.profile_secret}`;
      this.profile_result.md5sum = md5(this.profile_result.concat_string_secret);
    },
    inviteCalc(event) {
      this.invite_result = {};
      const struct_object = {
        slugs: this.invite_slugs,
        uid: this.invite_uid,
      };
      this.invite_result.dict_string = JSON.stringify(struct_object, null, 4);
      this.invite_result.concat_string = '';
      if (this.invite_slugs) {
        this.invite_result.concat_string += `slugs=${this.invite_slugs}`;
      }
      if (this.invite_uid) {
        this.invite_result.concat_string += `uid=${this.invite_uid}`;
      }
      this.invite_result.concat_string_secret = `${this.invite_result.concat_string}${this.invite_secret}`;
      this.invite_result.md5sum = md5(this.invite_result.concat_string_secret);
    },
    pubCalc(event) {
      this.pub_result = {};
      const struct_object = {
        img_url: this.pub_imgurl,
        title: this.pub_title,
        uid: this.pub_uid,
      };
      this.pub_result.dict_string = JSON.stringify(struct_object, null, 4);
      this.pub_result.concat_string = '';
      if (this.pub_imgurl) {
        this.pub_result.concat_string += `img_url=${this.pub_imgurl}`;
      }
      if (this.pub_title) {
        this.pub_result.concat_string += `title=${this.pub_title}`;
      }
      if (this.pub_uid) {
        this.pub_result.concat_string += `uid=${this.pub_uid}`;
      }
      this.pub_result.concat_string_secret = `${this.pub_result.concat_string}${this.pub_secret}`;
      this.pub_result.md5sum = md5(this.pub_result.concat_string_secret);
    },
    msgCalc(event) {
      this.msg_result = {};
      const struct_object = {
        template: this.msg_template,
        template_param: this.msg_template_param,
        uid: this.msg_uid,
      };
      this.msg_result.dict_string = JSON.stringify(struct_object, null, 4);
      this.msg_result.concat_string = '';
      if (this.msg_template) {
        this.msg_result.concat_string += `template=${this.msg_template}`;
      }
      if (this.msg_template_param) {
        this.msg_result.concat_string += `template_param=${this.msg_template_param}`;
      }
      if (this.msg_uid) {
        this.msg_result.concat_string += `uid=${this.msg_uid}`;
      }
      this.msg_result.concat_string_secret = `${this.msg_result.concat_string}${this.msg_secret}`;
      this.msg_result.md5sum = md5(this.msg_result.concat_string_secret);
    },
    achievementCalc(event) {
      this.achievement_result = {};
      const struct_object = {
        ach_id: this.achievement_ach_id,
        uid: this.achievement_uid,
      };
      this.achievement_result.dict_string = JSON.stringify(struct_object, null, 4);
      this.achievement_result.concat_string = '';
      if (this.achievement_ach_id) {
        this.achievement_result.concat_string += `ach_id=${this.achievement_ach_id}`;
      }
      if (this.achievement_uid) {
        this.achievement_result.concat_string += `uid=${this.achievement_uid}`;
      }
      this.achievement_result.concat_string_secret = `${this.achievement_result.concat_string}${this.achievement_secret}`;
      this.achievement_result.md5sum = md5(this.achievement_result.concat_string_secret);
    },


  },
  computed: {
    extraTooltipText() {
      return this.$i18n.t('tooltip');
    },
    pageTitle() {
      return this.$i18n.t('calc.title');
    },
    calcButton() {
      return this.$i18n.t('calc.button');
    },
    calcCard() {
      return [{
        id: 'billing',
        title: this.$i18n.t('calc.cards.billing.title'),
        text: '',
        email: window.atob('Yml6ZGV2QG15LmdhbWVz'),
      }, {
        id: 'auth',
        title: this.$i18n.t('calc.cards.auth.title'),
        text: '',
        email: window.atob('cHJAbXkuZ2FtZXM='),
      }, {
        id: 'auth_browser',
        title: this.$i18n.t('calc.cards.auth_browser.title'),
        text: '',
        email: window.atob('cHJAbXkuZ2FtZXM='),
      }, {
        id: 'profile',
        title: this.$i18n.t('calc.cards.profile.title'),
        text: '',
        email: window.atob('aW50ZWdyYXRpb25AbXkuZ2FtZXM='),
      }, {
        id: 'game_invite',
        title: this.$i18n.t('calc.cards.game_invite.title'),
        text: '',
      }, {
        id: 'publication',
        title: this.$i18n.t('calc.cards.publication.title'),
        text: '',
      }, {
        id: 'messages',
        title: this.$i18n.t('calc.cards.send_messages.title'),
        text: '',
      }, {
        id: 'achievement',
        title: this.$i18n.t('calc.cards.achievement.title'),
        text: '',
      }];
    },
  },
};
